import { z } from "zod";
import { MarketplaceCartItemSchema } from "./marketplace-cart-item";

export const MarketplaceCartSchema = z.object({
  Id: z.number(),
  HardwareItemAmount: z.number().optional(),
  // Referral / trial cart flags; omitted from the JSON when false or empty.
  HasTrial: z.boolean().optional(),
  IsFree: z.boolean().optional(),
  ReferralCode: z.string().optional(),
  LineItemAmount: z.number().optional(),
  Modified: z.string().optional(),
  Created: z.string().optional(),
  MonthlyOnly: z.boolean().optional(),
  AnnualOnly: z.boolean().optional(),
  ServiceOnly: z.boolean().optional(),
  SaaSItemAmount: z.number().optional(),
  ShipToCountry: z.string().optional(),
  ShipToCountryId: z.string().optional(),
  ShippingAmount: z.number().optional(),
  ShippingMethodCode: z.string().optional(),
  ShippingMethodName: z.string().optional(),
  ShippingMethodId: z.number().optional(),
  ShippingMethodDays: z.number().optional(),
  StateCode: z.number().optional(),
  TaxAmount: z.number().optional(),
  AccountId: z.string().optional(),
  ShipToAddress: z.string().optional(),
  ShipToCity: z.string().optional(),
  ShipToStateOrProvince: z.string().optional(),
  ShipToPostalCode: z.string().optional(),
  TotalAmount: z
    .number()
    .optional()
    .transform((value) => value || 0),
  TotalQnt: z
    .number()
    .optional()
    .transform((value) => value || 0),
  TotalToday: z
    .number()
    .optional()
    .transform((value) => value || 0),
  UserId: z.string().optional(),
  Items: MarketplaceCartItemSchema.array(),
});

export type MarketplaceCartType = z.infer<typeof MarketplaceCartSchema>;
